<template>
  <Modal
    id="popup-historico-mensageria"
    :title="'Histórico de Mensageria'"
    :active="active"
    @update:active="$emit('update:active', $event)"
    @close="closeModal()"
    data-testId="message-history-popup"
  >
    <div v-if="!isLoading" class="center">
      <vs-tabs alignment="center" v-model="activeTab">
        <vs-tab label="Segurado"> </vs-tab>
        <vs-tab label="Corretora"> </vs-tab>
      </vs-tabs>
      <vs-table stripe :data="list">
        <template #thead>
          <vs-th> Data/Hora</vs-th>
          <vs-th> Código</vs-th>
          <vs-th> Canal</vs-th>
          <vs-th> Destinatário</vs-th>
          <vs-th> Status</vs-th>
          <vs-th> Log de erro</vs-th>
          <vs-th> Observação</vs-th>
          <vs-th> Ações</vs-th>
        </template>
        <template slot-scope="{ data }">
          <template v-for="tr in data">
            <vs-tr :key="tr.idMensageriaFilaHistorico">
              <vs-td :data="tr.createdAt">
                {{ formatDate(tr.createdAt) }}
              </vs-td>

              <vs-td :data="tr.codigoMensagem">
                {{ tr.codigoMensagem }}
              </vs-td>

              <vs-td :data="tr.canal">
                {{ tr.canal }}
              </vs-td>

              <vs-td :data="tr.destinatario">
                {{ tr.destinatario }}
              </vs-td>

              <vs-td :data="hasError(tr)">
                <vs-chip :color="hasError(tr) ? 'danger' : 'success'">
                  {{ hasError(tr) ? 'Erro' : 'Sucesso' }}
                </vs-chip>
              </vs-td>

              <vs-td v-if="hasError(tr)" :data="tr.historico">
                {{ tr.historico }}
              </vs-td>
              <vs-td v-else> </vs-td>

              <vs-td :data="tr.observacao">
                {{ tr.observacao }}
              </vs-td>
              <vs-td>
                <div class="row-actions">
                  <vs-button
                    v-if="canExpandEvents(tr)"
                    radius
                    type="border"
                    color="primary"
                    icon="show_chart"
                    @click="toggleEvents(tr)"
                    v-tooltip="
                      isExpanded(tr) ? 'Ocultar rastreio' : 'Ver rastreio'
                    "
                    data-testId="message-events-toggle"
                  />
                  <vs-button
                    v-if="canShowResendButton"
                    @click="showResendConfirm(tr)"
                    radius
                    color="warning"
                    icon="cached"
                    type="filled"
                    v-tooltip="'Reenviar Mensagem'"
                  />
                </div>
              </vs-td>
            </vs-tr>

            <vs-tr
              v-if="isExpanded(tr)"
              :key="`${tr.idMensageriaFilaHistorico}-events`"
            >
              <vs-td colspan="8">
                <EmailTrackingTimeline
                  :events="events(tr)"
                  :loading="isLoadingEvents(tr)"
                  :error="eventsError(tr)"
                  @retry="loadEvents(tr)"
                />
              </vs-td>
            </vs-tr>
          </template>
        </template>
      </vs-table>
    </div>
  </Modal>
</template>
<script>
import Modal from '@/components/Modal.vue';
import EmailTrackingTimeline from './components/EmailTrackingTimeline.vue';
import messagingApi from '../../services/messaging.api';
import functions from '../../utils/functions';
import {
  MESSAGING_EMAIL_CHANNEL,
  MESSAGING_SUCCESS_STATUS,
} from '../../utils/constants';
import {
  PERMISSIONS_ACTIONS,
  PERMISSIONS_NAMES,
} from '../../constants/permissions';


export default {
  name: 'ModalHistoricoMensageria',
  components: {
    Modal,
    EmailTrackingTimeline,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    dadosProposta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hasBeenActive: false,
      isLoading: false,
      historic: [],
      activeTab: 0,
      tabs: {
        0: 'SEGURADO',
        1: 'CORRETORA',
      },
      expandedByHistoryId: {},
      eventsByHistoryId: {},
      loadingByHistoryId: {},
      errorByHistoryId: {},
    };
  },
  watch: {
    active: {
      immediate: true,
      async handler(newValue) {
        if (newValue && !this.hasBeenActive) {
          this.hasBeenActive = true;
          await this.getHistorico();
        }
      },
    },
  },
  computed: {
    list() {
      return this.historic.filter((item) => {
        return (
          item.tipoDestinatario &&
          item.tipoDestinatario.toUpperCase() === this.tabs[this.activeTab]
        );
      });
    },
    canShowResendButton() {
      return this.$can(
        PERMISSIONS_ACTIONS.MESSAGING_RESEND,
        PERMISSIONS_NAMES.QUOTATIONS,
      );
    },
    canShowTracking() {
      return this.$can(
        PERMISSIONS_ACTIONS.MESSAGING_TRACKING,
        PERMISSIONS_NAMES.QUOTATIONS,
      );
    },
  },
  methods: {
    closeModal() {
      this.$emit('update:active', false);
      this.$emit('close');
    },
    formatDate(data) {
      return functions.formatDatetimeWithMoment(data);
    },
    async getHistorico() {
      if (!this.dadosProposta || !this.dadosProposta.idApolice) {
        return;
      }
      this.isLoading = true;
      this.$vs.loading();
      try {
        this.historic = await messagingApi.getMessagingHistoryByPolicyId(
          this.dadosProposta.idApolice,
          this.dadosProposta.dadosCliente.idProspect,
        );
      } finally {
        this.$vs.loading.close();
        this.isLoading = false;
      }
    },
    hasError(history) {
      return !MESSAGING_SUCCESS_STATUS.includes(history.historico);
    },
    canExpandEvents(history) {
      return this.canShowTracking && history.canal === MESSAGING_EMAIL_CHANNEL;
    },
    isExpanded(history) {
      return !!this.expandedByHistoryId[history.idMensageriaFilaHistorico];
    },
    isLoadingEvents(history) {
      return !!this.loadingByHistoryId[history.idMensageriaFilaHistorico];
    },
    eventsError(history) {
      return this.errorByHistoryId[history.idMensageriaFilaHistorico];
    },
    events(history) {
      return this.eventsByHistoryId[history.idMensageriaFilaHistorico] || [];
    },
    toggleEvents(history) {
      const id = history.idMensageriaFilaHistorico;
      this.$set(this.expandedByHistoryId, id, !this.expandedByHistoryId[id]);

      if (this.expandedByHistoryId[id] && !this.eventsByHistoryId[id]) {
        this.loadEvents(history);
      }
    },
    async loadEvents(history) {
      const id = history.idMensageriaFilaHistorico;
      this.$set(this.loadingByHistoryId, id, true);
      this.$set(this.errorByHistoryId, id, null);
      try {
        const events = await messagingApi.getMessagingEmailEventsByHistoryId(
          id,
        );
        this.$set(this.eventsByHistoryId, id, events);
      } catch (error) {
        this.$set(
          this.errorByHistoryId,
          id,
          'Não foi possível carregar o rastreio desta mensagem.',
        );
      } finally {
        this.$set(this.loadingByHistoryId, id, false);
      }
    },
    resendMessage(message) {
      this.$vs.loading();
      const payload = {
        messagingHistoryId: message.idMensageriaFilaHistorico,
        channel: message.canal,
        receiverType: message.tipoDestinatario,
      };
      messagingApi
        .resendMessaging(payload)
        .then((response) => {
          if (response.success) {
            this.$vs.notify({
              position: 'top-center',
              title: 'Sucesso',
              text: 'Mensagem reenviada com sucesso',
              color: 'success',
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Erro',
            text: err.message,
            color: 'danger',
          });
        })
        .finally(() => {
          this.$vs.loading.close();
          this.getHistorico();
        });
    },
    showResendConfirm(message) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: `Confirmar`,
        text: 'Tem certeza que deseja reenviar essa mensagem?',
        acceptText: 'Enviar',
        cancelText: 'Cancelar',
        style: 'z-index: 999999',
        accept: () => this.resendMessage(message),
      });
    },
  },
};
</script>
<style>
#popup-historico-mensageria .vs-popup {
  width: 80vw !important;
  height: auto;
  min-height: 300px;
}

#popup-historico-mensageria .vs-popup--content {
  width: auto !important;
  padding: 1rem;
  font-size: 1rem;
  overflow-x: hidden;
}

#popup-historico-mensageria .vs-table--content {
  overflow-x: hidden;
}

#popup-historico-mensageria .vs-table--tbody-table {
  table-layout: fixed;
  min-width: 0;
}

#popup-historico-mensageria .vs-table--tbody-table th {
  white-space: nowrap;
}

#popup-historico-mensageria .vs-table--tbody-table td {
  white-space: normal;
  word-break: break-word;
}

#popup-historico-mensageria .con-vs-chip {
  white-space: nowrap;
}

#popup-historico-mensageria .row-actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.5rem;
}

#popup-historico-mensageria .vs-table--tbody-table th:nth-child(1) {
  width: 10%;
}
#popup-historico-mensageria .vs-table--tbody-table th:nth-child(2) {
  width: 16%;
}
#popup-historico-mensageria .vs-table--tbody-table th:nth-child(3) {
  width: 6%;
}
#popup-historico-mensageria .vs-table--tbody-table th:nth-child(4) {
  width: 15%;
}
#popup-historico-mensageria .vs-table--tbody-table th:nth-child(5) {
  width: 10%;
}
#popup-historico-mensageria .vs-table--tbody-table th:nth-child(6) {
  width: 14%;
}
#popup-historico-mensageria .vs-table--tbody-table th:nth-child(7) {
  width: 13%;
}
#popup-historico-mensageria .vs-table--tbody-table th:nth-child(8) {
  width: 16%;
}

.con-vs-dialog {
  z-index: 54000;
}

.tooltip {
  z-index: 54000;
}
</style>
